import { colors } from '../..'
import Metrics from '../Metrics'
import { BoxSizes, Chart, Dashboard } from './types'

const WFH: Dashboard = {
    id: 'WFH',
    name: 'WFH',
    daterange: true,
    metrics: [
        {
            type: Metrics.WFH_DEVICES_ONLINE,
            'box-size': BoxSizes.MID,
            chart: Chart.Doughnut,
            count: 'dashboard-count-devices',
            title: 'dashboard-devices-online',
        },
        {
            type: Metrics.GROUP,
            'box-size': BoxSizes.BIG,
            metrics: [
                {
                    type: Metrics.WFH_DWELLTIMELINE,
                    'box-size': BoxSizes.FULLWIDTH,
                    chart: Chart.Timeline,
                    color: [colors.bluelight],
                    legend: true,
                    title: 'dashboard-dwelltimeline',
                    count: 'dashboard-count-seconds-average',
                },
                {
                    type: Metrics.WFH_SESSIONS_TIMELINE,
                    'box-size': BoxSizes.FULLWIDTH,
                    chart: Chart.Timeline,
                    color: [colors.orange],
                    legend: true,
                    title: 'dashboard-sessions-timeline',
                    count: 'dashboard-count-sessions-average',
                },
            ],
        },
        {
            type: Metrics.WFH_STORES_TOP,
            'box-size': BoxSizes.MID,
            chart: Chart.List,
            title: 'dashboard-stores-top',
            count: 'dashboard-count-stores',
            'count-data': 'dashboard-count-interactions',
        },
        {
            type: Metrics.WFH_INTERACTIONS_PLAYLISTS,
            'box-size': BoxSizes.MID,
            chart: Chart.List,
            title: 'dashboard-interactions-playlists',
            count: 'dashboard-count-playlists',
            'count-data': 'dashboard-count-interactions',
        },
        {
            type: Metrics.WFH_INTERACTIONS_PRODUCTS,
            'box-size': BoxSizes.MID,
            chart: Chart.List,
            title: 'dashboard-interactions-products',
            count: 'dashboard-count-products',
            'count-data': 'dashboard-count-interactions',
        },
        {
            type: Metrics.GROUP,
            'box-size': BoxSizes.MID,
            metrics: [
                {
                    type: Metrics.WFH_INTERACTIONS_TOTAL,
                    'box-size': 'fullwidth',
                    title: 'dashboard-interactions-total',
                },
                {
                    type: Metrics.WFH_PLAYLIST_TOP,
                    'box-size': 'fullwidth',
                    title: 'dashboard-playlists-top',
                },
            ],
        },
    ],
}

export default WFH
